export const ApiPath = {
  COMMENTS: '/comments',
  DOWNTIME_DASHBOARD: '/downtime-dashboard',
  HROC_CHECKLISTS: '/hroc-checklists/api',
  KMS: '/kms',
  KPI: '/kpi',
  KPI_RESULT: '/kpi-result',
  POM_QUESTIONNARIES: '/pom-questionnaires',
  SHIFT_HANDOVER: '/shifthandover',
  RCFA_COMPLIANCE: '/rcfa-compliance/api',
  RUNNING_TIMES_ORCHESTRATOR: '/runningtimes-orchestrator',
  MACHINE_SENTRY_ACTIONS: '/machine-sentry-actions/api',
  OIL_ANALYSIS_ACTIONS: '/oil-analysis-actions/api',
  TASKS: '/tasks',
  UPM: '/upm',
  USERS: '/users',
  WORK_ORDERS: '/work-orders',
  EXPERT_SYSTEM: '/expert-system',
  SLA_KPI_TRACKING: '/sla-kpi-tracking/api',
  PROCESS_WORK_ORDERS: '/process-work-orders/api'
}
